import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { SizeRecord } from "../../helper/SizeRecord";

export const IdentifierDisplayRecord = Record({
  id: null,
  isAvatar: false,
  image: null,
  label: null,
  color: null,
  tooltip: null,
  tableCellSize: SizeRecord(),
  size: SizeRecord()
});

const data = {
  objects: {
    tableCellSize: "SizeRecord",
    size: "SizeRecord"
  }
};
createFromJS.registerCallback(
  "IdentifierDisplayRecord",
  createFromJS.createNestedCallback(IdentifierDisplayRecord, data)
);
